/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly " $refType": "ProfileQueryLocal";
};
export type ProfileQueryLocal$data = ProfileQueryLocal;
export type ProfileQueryLocal$key = {
    readonly " $data"?: ProfileQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'abdb65fd401f6ffbf330e910f998ec8c';
export default node;
